<style lang="css" scoped>
.oauth-sign-in {
  /* background: red; */
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div class="main-login-page">
    <div class="login-form">
      <div class="img-outside">
        <div class="card-left-title mb-5">AI - CXR SCREENING</div>
        <v-img
          contain
          class="mx-auto card-right-img"
          :src="require('@/assets/images/loginpage/loginImage.png')"
        />
      </div>
      <v-card class="login-card" elevation="24">
        <div class="card-left">
          <div class="card-left-title mb-5">AI - CXR SCREENING</div>
          <v-img
            contain
            class="mx-auto card-right-img"
            :src="require('@/assets/images/loginpage/loginImage.png')"
          />
        </div>
        <div class="card-right">
          <v-img
            contain
            class="logo-company pb-8 mx-5"
            :src="require('@/assets/images/loginpage/logoLogin.png')"
          />
          <div class="card-right-title mb-5">
            เข้าสู่ระบบด้วยบัญชีผู้ใช้งานของคุณ
          </div>
          <div class="form-box">
            <div v-show="textError" class="text-error">
              ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง
            </div>
            <v-form ref="formSignIn" v-model="valid">
              <v-text-field
                class="custom-text-field"
                :class="textError ? 'textfielderror' : 'textfieldsuccess'"
                v-model="signInData.username"
                :rules="[
                  Rule.noInPut,
                  Rule.noSpace,
                  Rule.englishOnly,
                  Rule.emailOnly,
                ]"
                placeholder="อีเมล"
                label="ชื่อผู้ใช้(อีเมล)"
                dense
                outlined
                rounded
                @keyup.enter="validateLogin()"
              ></v-text-field>
              <v-text-field
                class="custom-text-field"
                :class="textError ? 'textfielderror' : 'textfieldsuccess'"
                v-model="signInData.password"
                :rules="[Rule.noInPut, Rule.noSpace]"
                :append-icon="signInData.show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="signInData.show ? 'text' : 'password'"
                @click:append="signInData.show = !signInData.show"
                placeholder="รหัสผ่าน"
                label="รหัสผ่าน"
                dense
                outlined
                rounded
                @keyup.enter="statusTermAndCondition ? validateLogin() : ''"
              >
              </v-text-field>
              <div>
                <v-row align-item="">
                  <v-col cols="2" style="padding-top: 18px; margin-top: 0">
                    <v-checkbox v-model="statusTermAndCondition"></v-checkbox>
                  </v-col>
                  <v-col cols="10">
                    รับทราบ
                    <a
                      target="_blank"
                      href="https://manageai.co.th/static/pdf/Policy_manageAi.pdf"
                      style="text-decoration: none"
                    >
                      เงื่อนไขการให้บริการ </a
                    >,
                    <a
                      target="_blank"
                      href="https://manageai.co.th/static/pdf/Manage_AI_PDPA.pdf"
                      style="text-decoration: none"
                    >
                      นโยบายคุ้มครองข้อมูลส่วนบุคคล
                    </a>
                    และ
                    <a
                      target="_blank"
                      href="https://manageai.co.th/static/pdf/discliamer.pdf"
                      style="text-decoration: none; white-space: nowrap"
                    >
                      ข้อจำกัดความรับผิดชอบ
                    </a>
                  </v-col>
                </v-row>
              </div>
              <div class="forget-password mt-n3">
                <v-btn
                  class="forget-password-btn"
                  text
                  rounded
                  @click="dialogForget = true"
                  >ลืมรหัสผ่าน ?</v-btn
                >
                <v-btn
                  @click.prevent="validateLogin"
                  type="submit"
                  class="my-3 sign-in-btn"
                  color="primary"
                  :loading="loading"
                  block
                  rounded
                  :disabled="!statusTermAndCondition || !valid"
                  >เข้าสู่ระบบ</v-btn
                >
              </div>
              <div class="oauth-sign-in">
                <v-row>
                  <v-col>
                    <OauthBtn
                      block
                      rounded
                      color="white"
                      :image="require('@/assets/images/oneid.png')"
                      text="OneID"
                      @click="SignInOneIDAccount"
                      :disabled="!statusTermAndCondition"
                    >
                    </OauthBtn>
                  </v-col>
                  <v-col>
                    <OauthBtn
                      block
                      rounded
                      color="white"
                      :image="require('@/assets/images/providerid.png')"
                      text="provider ID"
                      @click="SignInHealthIDAccount"
                      :disabled="!statusTermAndCondition"
                    >
                    </OauthBtn>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </div>
        </div>
      </v-card>
      <DialogAnnounce :announce="announce" v-model="dialogCarousel" />
      <DialogForgetPassword
        ref="resetpassword"
        v-model="dialogForget"
        @emailUser="resetPassword"
      />
    </div>
  </div>
</template>

<script>
import OauthBtn from '@/components/Button/OauthBtn.vue'
import DialogAnnounce from '../views/../components/Forms/DialogAnnounce.vue'
import DialogForgetPassword from '../views/../components/Forms/DialogForgetPassword.vue'

export default {
  components: {
    DialogAnnounce,
    DialogForgetPassword,
    OauthBtn
  },
  mounted () {
    setTimeout(() => {
      this.$vuetify.theme.dark = localStorage.getItem('darkMode') === 'true'
    }, 200)
  },
  data () {
    return {
      statusTermAndCondition: false,
      mailUser: '',
      dialogCarousel: false,
      dialogForget: false,
      resetEmail: [],
      textError: false,
      textFieldError: false,
      loading: false,
      signInData: {
        username: '',
        password: '',
        show: false
      },
      valid: false,
      firstname: '',
      lastname: '',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      announce: [],
      signatureKey: '',
      dataEncryptionAES: '',
      accessTokenToLogin: ''
    }
  },
  async created () {
    // console.log(this.$route.params.provider)
    // ตรวจสอบว่ามี Authorization code ใน Query Parameter หรือไม่
    if (this.$route.params.provider === 'providerid') {
      if (this.$route.query.code !== undefined) {
        this.loading = true
        const payload = {
          authorization_code: this.$route.query.code,
          redirect_uri: `${window.location.origin}${process.env.VUE_APP_BASE_URL}login/providerid`
        }
        this.$router.replace({ query: null }).catch(() => {})
        const res = await this.signInProvidAuthorizationCode(payload)
        this.loading = false
        if (res.code === 200) {
          if (res.status === true) {
            localStorage.setItem('Accesstoken', res.data.accesstoken)
            this.$router.push({ name: 'homePage' }).catch(() => {})
          }
          if (res.status === false) {
            this.textError = true
            this.textFieldError = true
          }
        } else {
          // this.antmessage.error(res.message)
          this.notification.error({
            message: 'เกิดข้อผิดผลาด',
            description: res.message,
            placement: 'bottomRight'
          })
        }
      }
    }
    if (this.$route.params.provider === 'oneid') {
      if (this.$route.query.code !== undefined) {
        this.loading = true
        const payload = {
          authorization_code: this.$route.query.code,
          redirect_uri: `${window.location.origin}${process.env.VUE_APP_BASE_URL}login/oneid`
        }
        this.$router.replace({ query: null }).catch(() => {})
        const res = await this.signInOneIDAuthorizationCode(payload)
        this.loading = false
        if (res.code === 200) {
          if (res.status === true) {
            localStorage.setItem('Accesstoken', res.data.accesstoken)
            this.$router.push({ name: 'homePage' }).catch(() => {})
          }
          if (res.status === false) {
            this.textError = true
            this.textFieldError = true
          }
        } else {
          // this.antmessage.error(res.message)
          this.notification.error({
            message: 'เกิดข้อผิดผลาด',
            description: res.message,
            placement: 'bottomRight'
          })
        }
      }
    }

    this.initAnnouncerToday()
  },
  methods: {
    async SignInOneIDAccount () {
      // TODO Edit Here --------------------------
      const clientID = process.env.VUE_APP_ONEID_CLIENT_ID
      // const redirectUri = `${window.location.origin}/login`
      // const redirectUri = `${window.location.origin}${process.env.VUE_APP_BASE_URL}login`
      const redirectUri = `${window.location.origin}${process.env.VUE_APP_BASE_URL}login/oneid`
      const responseType = 'code'
      const scope = 'title+first_name+last_name+birth_date+email+tel+pic'
      // TODO Edit Here --------------------------
      const uri = `${process.env.VUE_APP_ONEID_URL}/oauth/authorize?client_id=${clientID}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`
      location.replace(encodeURI(uri))
    },
    async SignInHealthIDAccount () {
      // TODO Replace Url and Reload
      const res = await this.getProviderIDCredential()
      const clientID = res.data.client_id
      // const clientID = '9b676974-d41b-4840-b747-9e34cbda23dc'
      const redirectUri = `${window.location.origin}${process.env.VUE_APP_BASE_URL}login/providerid`
      const url = `${process.env.VUE_APP_PROVIDER_ID_URL}/oauth/redirect?client_id=${clientID}&redirect_uri=${redirectUri}&response_type=code`
      window.location.replace(url)
      // TODO Get Authen Code
      // const urlParams = new URLSearchParams(window.location.search)
      // const code = urlParams.get('code')
      // console.log(code)
      // TODO ขอ Accesstoken
      // console.log(code)
    },

    async initAnnouncerToday () {
      const res = await this.getAnnouncerToday()
      if (res.status) {
        this.announce = res.data
        if (this.announce.length !== 0) {
          this.dialogCarousel = true
        }
      } else {
        // this.antmessage.error(res.message)
        this.notification.error({
          message: 'เกิดข้อผิดผลาด',
          description: res.message,
          placement: 'bottomRight'
        })
      }
    },
    async validateLogin () {
      if (this.$refs.formSignIn.validate()) {
        this.loading = true
        await this.getAESSignatureForLogin(this.signInData)
        // if (this.accessTokenToLogin != null) {
        const payload = {
          username: this.dataEncryptionAES.username,
          password: this.dataEncryptionAES.password
        }
        const res = await this.signIn(payload)
        this.loading = false
        if (res.code === 200) {
          if (res.status === true) {
            localStorage.setItem('Accesstoken', res.data.accesstoken)
            this.$router.push({ name: 'homePage' }).catch(() => {})
          }
          if (res.status === false) {
            // this.textError = true
            // this.textFieldError = true
            // this.antmessage.error('ผู้ใช้หรือรหัสผ่านไม่ถูกต้อง')
            await this.notification.error({
              message: 'เกิดข้อผิดผลาด',
              description: 'ผู้ใช้หรือรหัสผ่านไม่ถูกต้อง',
              placement: 'bottomRight'
            })
          }
        } else {
          // this.antmessage.error(res.message)
          this.notification.error({
            message: 'เกิดข้อผิดผลาด',
            description: res.message,
            placement: 'bottomRight'
          })
        }
        // }
      }
    },
    async getAESSignatureForLogin (val) {
      // ยิง APi ไปเอา AESSignature
      this.dataEncryptionAES = {}
      const res = await this.GetAESSignature()
      if (res.status) {
        this.signatureKey = res.data.signature //
        const usernameEncryptionAES = this.AESEncryption(
          this.signatureKey,
          val.username
        )
        const passwordEncryptionAES = this.AESEncryption(
          this.signatureKey,
          val.password
        )
        this.dataEncryptionAES = {
          username: `encryption-${usernameEncryptionAES}-encryption`,
          password: `encryption-${passwordEncryptionAES}-encryption`
        }
      } else {
        // this.antmessage.error(res.message)
        this.notification.error({
          message: 'เกิดข้อผิดผลาด',
          description: res.message,
          placement: 'bottomRight'
        })
      }
    },
    async resetPassword (val) {
      // Swal.fire("Good job!", "You clicked the button!", "success");
      const payload = {
        email: val
      }
      const res = await this.sendEmailresetPasswordUser(payload)
      if (res.status) {
        this.$swal({
          allowEnterKey: false,
          title: 'สำเร็จ',
          text: 'กรุณาตรวจเช็คอีเมลเพื่อเปลี่ยนรหัสผ่านในอีเมลของท่าน',
          icon: 'success',
          showConfirmButton: false,
          showCancelButton: false,
          timer: 3000
        })
        this.dialogForget = false
        this.$refs.resetpassword.reset()
      } else {
        if (res.message === 'email is not exists') {
          this.$swal({
            allowEnterKey: false,
            title: 'ไม่สำเร็จ',
            text: 'ข้อมูลไม่ถูกต้องกรุณาเช็คอีเมล',
            icon: 'error',
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          // this.antmessage.error(res.message)
          this.notification.error({
            message: 'เกิดข้อผิดผลาด',
            description: res.message,
            placement: 'bottomRight'
          })
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
>>> .custom-text-field input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
>>> .textfieldsuccess.v-text-field--outlined fieldset {
  border: 1px solid var(--v-primary-base);
  color: var(--v-primary-base) !important;
}
>>> .textfielderror.v-text-field--outlined fieldset {
  border: 1px solid var(--v-error-base);
  color: var(--v-primary-base) !important;
}

>>> .textfieldsuccess.v-text-field--outlined.v-input--dense .v-label {
  color: var(--v-primary-base) !important;
}
>>> .textfielderror.v-text-field--outlined.v-input--dense .v-label {
  color: var(--v-error-base) !important;
}
>>> .textfieldsuccess .v-input__append-inner .v-input__icon .v-icon {
  color: var(--v-primary-base) !important;
}
>>> .textfielderror .v-input__append-inner .v-input__icon .v-icon {
  color: var(--v-error-base) !important;
}

.text-error {
  color: red;
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: -10px;
  font-size: 13px;
}
.form-box {
  width: 60%;
}
.sign-in-btn {
  font-weight: 400;
  font-size: 18px;
  color: var(--v-bgPrimary-base);
}
.forget-password {
  text-align: right;
}
.forget-password-btn {
  font-weight: 300;
  font-size: 16px;
  color: var(--v-primary-base);
}
.logo-company {
  width: 95% !important;
  max-width: 260px !important;
}
.card-left-title {
  text-align: center;
  width: 100%;
  font-weight: 500;
  font-size: 30px;
  color: var(--v-bgPrimary-base);
}
.card-left {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  width: 55%;
  background: linear-gradient(
    136.16deg,
    var(--v-gradient1-base) 0%,
    var(--v-gradient2-base) 100%
  );
  border-top-left-radius: 20px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 20px !important;
}
.card-right {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  width: 45%;
}
.card-right-img {
  max-width: 80% !important;
}
.card-right-title {
  color: var(--v-tprimary-base);
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 16px;
}
.main-login-page {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 20px;
  justify-content: center;
  align-items: center;
  background-image: url("@/../public/img/Rectangle.svg");
  background-position: center;
  background-size: cover;
}

.login-form {
  max-width: 1200px;
  width: 60%;
  height: 70%;
  min-height: 500px;
}

.login-card {
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 20px;
}
.img-outside {
  display: none;
}
@media only screen and (max-width: 1400px) {
  .login-form {
    width: 80%;
  }
  .form-box {
    width: 80%;
  }
}
@media only screen and (max-width: 1000px) {
  .login-form {
    width: 95%;
  }
}
@media only screen and (max-width: 750px) {
  .login-form {
    height: fit-content;
  }
  .card-left {
    display: none;
  }
  .card-right {
    width: 100%;
    height: fit-content;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .card-right-img {
    max-width: 400px !important;
  }
  .login-card {
    max-width: 500px;
    flex-wrap: wrap;
    height: fit-content;
  }
  .img-outside {
    width: 100%;
    display: inline;
  }
  .login-form {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
  }
  .main-login-page {
    background: linear-gradient(
      136.16deg,
      var(--v-gradient1-base) 0%,
      var(--v-gradient2-base) 100%
    );
  }
  .logo-company {
    width: 65% !important;
    max-width: 200px !important;
  }
}

.find-user-comfirm {
  font-weight: 400;
  font-size: 18px;
  color: var(--v-bgPrimary-base);
}
.find-user-cancel {
  font-weight: 400;
  font-size: 18px;
  color: var(--v-bgPrimary-base);
}
</style>
